import { Injectable } from '@angular/core';
import { Router, Resolve, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';

import {
  // DataHelperService,
  BackendService
} from './../shared/index';

@Injectable()
export class CoverageFormResolverService implements Resolve<any> {

  constructor(
    private _router: Router,
    // private _dh: DataHelperService,
    private _backend: BackendService
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return Promise.all([
      this._backend.getSetting(),
      this._backend.getAllFormData(),
    ]).then((data) => {
      if (data[0] !== {} && data[1] !== {}) {
        return data;
      } else {
        return null;
      }
    });
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./resources/themes/pandax/bobtail/app/coverage-form/coverage-form-resolver.service.ts